import { render, staticRenderFns } from "./SearchProvider.vue?vue&type=template&id=3f80d90d&"
import script from "./SearchProvider.vue?vue&type=script&lang=js&"
export * from "./SearchProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports